// @flow
import React from 'react';
import {View, StyleSheet} from 'react-native';
import {connect} from 'react-redux';
import {reduxForm} from 'redux-form';
import {compose} from 'react-recompose';
import ValidateEmail from '../SignUp/ValidateEmail/ValidateEmail';
import ValidationService from '../../lib/validation';
import {isLoadingSelector, errorSelector} from '../../modules/LoadingStatus/reducer';
import {maskEmail} from '../../lib/maskEmail';
import I18n from '../../lib/i18n';

const validate = values => ({
  _error: ValidationService.validateCode(values.code),
});

const mapStateToProps = (state, ownProps) => {
  const email = ownProps.route?.params?.email ?? '';
  const maskedEmail = maskEmail(email);
  const attemptsRemaining = errorSelector(state, 'otpAttemptsRemaining');
  return {
    // T6: display masked email to avoid exposing it in full (doc fonctionnelle §6)
    email: maskedEmail,
    isLoading: isLoadingSelector(state, 'loginWithOtp'),
    isResending: isLoadingSelector(state, 'loginResendOtp'),
    // T5: pass remaining attempts count; only shown when not null (OTP login context only)
    attemptsRemaining: typeof attemptsRemaining === 'number' ? attemptsRemaining : null,
    titleOverride: I18n.t('Login.OtpVerification.title'),
    textOverride: I18n.t('Login.OtpVerification.text', {email: maskedEmail}),
    noEmailLinkOverride: I18n.t('Login.OtpVerification.noEmailLink'),
    modalTitleOverride: I18n.t('Login.OtpVerification.modal.title'),
    modalTextOverride: I18n.t('Login.OtpVerification.modal.text'),
    modalResendOverride: I18n.t('Login.OtpVerification.modal.resend'),
    // T8: renamed from "Change my email" to "Back to login" for the OTP login context
    modalUpdateTextOverride: I18n.t('Login.OtpVerification.modal.update'),
  };
};

const mapDispatchToProps = (dispatch, ownProps) => ({
  onSubmit: values =>
    dispatch({type: 'SUBMIT_OTP', payload: {otpCode: values.code}}),
  resendEmail: () => dispatch({type: 'RESEND_LOGIN_OTP'}),
  onUpdateEmail: () => ownProps.navigation.goBack(),
});

const enhance = compose(
  connect(mapStateToProps, mapDispatchToProps),
  reduxForm({form: 'otpVerification', validate}),
);

const EnhancedValidateEmail = enhance(ValidateEmail);

class OtpVerification extends React.Component<Object> {
  _unsubscribe: ?Function;

  componentDidMount() {
    this._unsubscribe = this.props.navigation.addListener('beforeRemove', () => {
      this.props.cancelOtp();
    });
  }

  componentWillUnmount() {
    if (this._unsubscribe) this._unsubscribe();
  }

  render() {
    const {cancelOtp, ...rest} = this.props;
    return (
      <View testID="otpVerification-screen" style={styles.screen}>
        <EnhancedValidateEmail {...rest} />
      </View>
    );
  }
}

const styles = StyleSheet.create({
  screen: {flex: 1},
});

export default connect(null, dispatch => ({
  cancelOtp: () => dispatch({type: 'OTP_CANCELLED'}),
}))(OtpVerification);
